import { FormState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { AgentFormFields, InviteAgentRow } from "./inviteAgentRow";
import styles from "./signUpCommon.css";

export interface AgentWithID {
  form: FormState<AgentFormFields>;
  id: string;
}

interface Props {
  agentsFields: Array<AgentWithID>;
  addAgent: () => void;
  removeAgent: (id: string) => () => void;
}

export const AddAgents: React.SFC<Props> = observer(({ agentsFields, addAgent, removeAgent }) => (
  <div className={styles["add-agents-form"]}>
    <div className={styles.scroll}>
      {agentsFields.map(({ form, id }: AgentWithID, i: number) => (
        <InviteAgentRow
          key={id}
          form={form}
          errorHintTop={!!i && i + 1 === agentsFields.length}
          removeAgent={removeAgent(id)}
        />
      ))}
    </div>
    <button type={"button"} className={styles["add-agent"]} onClick={addAgent}>
      <L10n id={"settings.advisers.invite.addEmail"} />
    </button>
  </div>
));
